
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { MealCountDto, MealCountHardValidator } from "@/models";
  import { mcEvents, eventBus } from "@/utils";
  import { mcLabels, MealCountDtoViewModel } from '@/view-models';

  @Component
  export default class McTally extends Vue {
    @Prop() readonly model!: MealCountDtoViewModel;

    labels = mcLabels.mealCountTally;
    validator = new MealCountHardValidator();

    get tally() {
      return this.model.tally;
    }

    availableWarning: string = '';
    servedWarning: string = '';
    leftoverWarning: string = '';

    availableWarningIcon: boolean = false;
    warningTooltip: string = "Invalid Meal Count: The combined amount of meals served, wasted, and incomplete can never exceed 'Available' meals."
    showTooltip: boolean = false;

    created() {
      this.tallyNotify();

      eventBus.$on(mcEvents.tallyNotify, this.tallyNotify);
    }

    tallyNotify() {
      this.availableWarning = '';
      this.servedWarning = '';
      this.leftoverWarning = '';
      this.availableWarningIcon = false;

      const validations = this.validator.validate(<MealCountDto>this.model.mealCounts);
      if (validations['servingLines']) {
        this.availableWarning = 'warning';
        this.availableWarningIcon = true;
      }
    }
  }

